import React, { useEffect, useState } from 'react';
import { CustomerWorkoutSessionCreateSetFormData } from '../beans/customer.workout.session.create.form.data';
import moment from 'moment';
import {
    ProgramSession,
    ProgramSessionCreateRequest,
    ProgramSessionSetCreateRequest,
    ProgramSessionSetStatusEnum,
    ProgramSessionUpdatDateRequest,
    Session,
    SetTransitByExerciseRequest,
    User,
    Workout,
} from 'src/api/entities';
import { FormManager } from 'src/_shared/managers/form.manager';
import { NavigationManager } from 'src/_shared/managers/navigation.manager';
import { PopupManager } from 'src/_shared/managers/popup.manager';
import { WorkoutManager } from 'src/_shared/managers/workout.manager';
import { WorkoutSessionManager } from 'src/_shared/managers/workout.session.manager';
import { WorkoutSessionSetManager } from 'src/_shared/managers/workout.session.set.manager';
import { WorkoutSetManager } from 'src/_shared/managers/workout.set.manager';
import { RouteEnum } from 'src/_shared/routes';
import { store } from 'src/_shared/store/configure';
import { useStoreSelector } from 'src/_shared/store/hook';
import { WorkoutSession } from 'src/api/entities/workout-session';
import { PopupType } from 'src/features/_shared/components/Popup/popup.item';
import {
    WorkoutSessionCreateUpdate,
    setWorkoutSessionItems,
    setWorkoutSessionItem,
    setWorkoutSessionSetItems,
    setSelectedWorkoutSessionDate,
    resetWorkoutSessionCreateUpdate,
    setSessionSummary,
    setSelectedWorkoutItem,
    setAvailableWorkoutItems,
} from 'src/features/workout/store/workout.session.slice';
import { Button } from 'src/features/_shared/components/Button/button.component';
import { Calendar } from 'src/features/_shared/components/DatePicker/datepicker.component';
import { DashboardManager } from 'src/_shared/managers/dashboard.manager';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import { EventCalendar } from 'src/features/exercise/utils/eventcalendar';
import { setWorkoutItems } from 'src/features/workout/store/workout.slice';
import Select from 'react-select';
import { reactSelectStyles, reactSelectComponents } from 'src/features/_shared/styles/react-select.styles';
import { WorkoutSessionSetTransitManager } from 'src/_shared/managers/workout.session.set.transit.manager';
import { PageTransition } from 'src/features/_shared/components/PageTransition/page.transition.component';
import { EmptyState } from 'src/features/_shared/components/EmptyState/empty.state.component';

interface SelectableWorkout {
    label: string;
    value: number;
}

export const CustomerSessionsView: React.FC = () => {
    const dashboardManager = DashboardManager.getInstance();
    const navigationManager = NavigationManager.getInstance();
    const workoutManager = WorkoutManager.getInstance();
    const workoutSetManager = WorkoutSetManager.getInstance();
    const workoutSessionManager = WorkoutSessionManager.getInstance();
    const workoutSessionSetManager = WorkoutSessionSetManager.getInstance();
    const workoutSessionSetTransitManager = WorkoutSessionSetTransitManager.getInstance();
    const notificationManager = PopupManager.getInstance();

    const workoutSessions: WorkoutSession[] = useStoreSelector(state => state.reducer.workoutSessionSlice.workoutSessions);
    const workoutSessionCreateUpdate: WorkoutSessionCreateUpdate = useStoreSelector(state => state.reducer.workoutSessionSlice.workoutSessionCreateUpdate);
    const customerItem: User = useStoreSelector(state => state.reducer.customerSlice.customer);
    const [selectedDate, setSelectedDate] = useState<string>('');
    const [availableWorkoutTitles, setAvailableWorkoutTitles] = useState<SelectableWorkout[]>([]);

    const getWorkouts = async () => {
        const response = (await workoutManager.search(customerItem.id)).data!;
        console.log(response);
        store.dispatch(setAvailableWorkoutItems({ response }));
        const selectableWorkouts: SelectableWorkout[] = [];
        response.forEach(work => {
            const selectableWorkout: SelectableWorkout = {
                label: work.title!,
                value: work.id!,
            };
            selectableWorkouts.push(selectableWorkout);
        });
        setAvailableWorkoutTitles(selectableWorkouts);
    };

    const getWorkoutSessions = async () => {
        const value = (await workoutSessionManager.searchCustomerSessions(customerItem.id)).data!;
        console.log(value);
        store.dispatch(setWorkoutSessionItems({ value }));
    };

    const handleCreateWorkoutSession = async () => {
        console.log(customerItem);
        console.log(workoutSessionCreateUpdate);
        console.log(selectedDate);
        const request: ProgramSessionCreateRequest = {
            data: {
                author: {
                    id: customerItem.id!,
                    name: customerItem.username,
                },
                details: {
                    date: workoutSessionCreateFormData.getValues('sessionDate'),
                    id: workoutSessionCreateFormData.getValues('sessionID'),
                    name: workoutSessionCreateFormData.getValues('sessionName'),
                },
            },
        };
        if (workoutSessionCreateUpdate.selectedWorkout != undefined && workoutSessionCreateUpdate.selectedWorkout.id! != undefined) {
            const programSession: ProgramSession = await workoutSessionManager.create(request);
            const workoutSets = (await workoutSetManager.search(workoutSessionCreateFormData.getValues('sessionID'))).data;
            if (workoutSets != undefined && workoutSets.length > 0) {
                workoutSets.forEach(workoutSet => {
                    const workoutSetCreating: ProgramSessionSetCreateRequest = {
                        sessionID: programSession.id!,
                        authorId: customerItem.id!,
                        authorName: customerItem.username,
                        status: ProgramSessionSetStatusEnum.Done,
                        data: {
                            details: {
                                date: programSession.sessionDate,
                                exercise: {
                                    group: workoutSet.exerciseGroup,
                                    name: workoutSet.exerciseName,
                                    uuid: workoutSet.exerciseUuid,
                                },
                                reps: workoutSet.reps,
                                rest: workoutSet.rest,
                                weight: workoutSet.weight,
                                rir: workoutSet.rir,
                                rpe: workoutSet.rpe,
                            },
                        },
                    };
                    workoutSessionSetManager.create(programSession.id!, workoutSetCreating);
                    const transitRequest: SetTransitByExerciseRequest = {
                        sessionID: workoutSetCreating.sessionID,
                        authorID: customerItem.id!,
                    };
                    workoutSessionSetTransitManager.transitBySession(transitRequest);
                });
            }
            await getWorkoutSessions()
            notificationManager.hide();
        }
    };

    const handleDuplicateWorkoutSession = async (session: ProgramSession) => {
        console.log(customerItem);
        console.log(workoutSessionCreateUpdate);
        console.log(selectedDate);
        const request: ProgramSessionCreateRequest = {
            id: session.id!,
            data: {
                author: {
                    id: customerItem.id!,
                    name: customerItem.username,
                },
                details: {
                    date: workoutSessionCreateFormData.getValues('sessionDate'),
                    id: session.sessionID,
                    name: session.sessionName,
                },
            },
        };
        const newSession: ProgramSession = await workoutSessionManager.duplicate(request);
        const transitRequest: SetTransitByExerciseRequest = {
            sessionID: newSession.id,
            authorID: customerItem.id!,
        };
        workoutSessionSetTransitManager.transitBySession(transitRequest);
        await getWorkoutSessions();
        notificationManager.hide();
    };

    useEffect(() => {
        getWorkoutSessions();
        getWorkouts();
    }, []);

    const getSessionSummary = async (sesssionID: number) => {
        const response = await dashboardManager.getSessionSummary(sesssionID);
        store.dispatch(setSessionSummary({ response }));
    };

    const handleWorkoutSessionDetail = async (workoutID: number) => {
        const getWorkoutData = async () => {
            const response = await workoutSessionManager.getById(workoutID);
            store.dispatch(setWorkoutSessionItem({ response }));
            console.log(workoutID);
            console.log(response.id!);
            if (response != undefined) {
                const sets = (await workoutSessionSetManager.search(workoutID)).data;
                if (sets != undefined) {
                    store.dispatch(setWorkoutSessionSetItems({ sets }));
                }
            }
        };
        await getWorkoutData();
        await getSessionSummary(workoutID);
        navigationManager.navigateTo(RouteEnum.workoutSessionsSets);
    };

    const handleWorkoutSessionDelete = async (workoutSessionID: number) => {
        await workoutSessionManager.delete(workoutSessionID);
        getWorkoutSessions();
    };

    const handleStartChangeDate = async (workoutSessionID: number, sessionDate: string) => {
        workoutSessionCreateFormData.setValue('sessionID', workoutSessionID);
        workoutSessionCreateFormData.setValue('sessionDate', sessionDate);
        setNewSessionDate(true);
    };

    const handleChangeDate = async () => {
        const request: ProgramSessionUpdatDateRequest = {
            date: workoutSessionCreateFormData.getValues('sessionDate'),
        };
        await workoutSessionManager.updateDate(workoutSessionCreateFormData.getValues('sessionID'), request);
        getWorkoutSessions();
    };

    const handleSetDate = (date: any) => {
        const value = date as string;
        store.dispatch(setSelectedWorkoutSessionDate({ value }));
        console.log(value);
        setSelectedDate(value);
        console.log(selectedDate);
    };

    const resetCustomerCreateUpdateForm = () => {
        store.dispatch(resetWorkoutSessionCreateUpdate());
    };

    const workoutSessionCreateFormData = FormManager.getInstance().buildFormProxy<CustomerWorkoutSessionCreateSetFormData>(
        CustomerWorkoutSessionCreateSetFormData,
        handleCreateWorkoutSession,
        {
            sessionDate: workoutSessionCreateUpdate.sessionDate,
            sessionID: workoutSessionCreateUpdate.selectedWorkout != undefined ? workoutSessionCreateUpdate.selectedWorkout.id : 0,
        },
        'onChange',
    );

    const [newSessionDate, setNewSessionDate] = useState(new Boolean(false));
    const localizer = momentLocalizer(moment);

    const sessionEvents = () => {
        const events: EventCalendar[] = [];
        workoutSessions.map(sess => {
            const event: EventCalendar = {
                id: sess.id!,
                start: moment(sess.sessionDate).toDate(),
                end: moment(sess.sessionDate).toDate(),
                title: sess.sessionName!,
                allDay: true,
            };
            events.push(event);
        });
        return events;
    };

    const handleSelectWorkout = async (choice: number) => {
        const value = await workoutManager.getById(choice);
        store.dispatch(setSelectedWorkoutItem({ value }));
        console.log(workoutSessionCreateUpdate.selectedWorkout);
    };

    const handleStartCreate = () => {
        notificationManager.show({
            title: 'Nuova seduta',
            type: PopupType.Info,
            icon: 'bi-calendar-check-fill',
            children: (
                <div className='App mt-2'>
                    <div className='col'>
                        <div className='d-flex justify-content-between mb-3' style={{ gap: 10 }}>
                            <div>
                                <input
                                    id='startDate'
                                    className='form-control'
                                    type='date'
                                    {...workoutSessionCreateFormData.register('sessionDate')}
                                    onChange={event => {
                                        workoutSessionCreateFormData.setValue('sessionDate', event.target.value as string);
                                        console.log(workoutSessionCreateFormData.getValues('sessionDate'));
                                        handleSetDate(event.target.value as string);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            ctas: {
                primary: {
                    cta: async () => {
                        await handleCreateWorkoutSession()
                    },
                },
                secondary: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
                close: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
            },
        });
    };

    const handleStartDuplicate = (session: ProgramSession) => {
        notificationManager.show({
            title: 'Duplica seduta',
            type: PopupType.Info,
            icon: 'bi-copy',
            children: (
                <div className='App mt-2'>
                    <div className='col'>
                        <div className='d-flex justify-content-between mb-3' style={{ gap: 10 }}>
                            <div>
                                <input
                                    id='startDate'
                                    className='form-control'
                                    type='date'
                                    {...workoutSessionCreateFormData.register('sessionDate')}
                                    onChange={event => {
                                        workoutSessionCreateFormData.setValue('sessionDate', event.target.value as string);
                                        console.log(workoutSessionCreateFormData.getValues('sessionDate'));
                                        handleSetDate(event.target.value as string);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            ctas: {
                primary: {
                    cta: async () => {
                        await handleDuplicateWorkoutSession(session)
                    },
                },
                secondary: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
                close: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
            },
        });
    };

    const handleStartCreateSession = () => {
        notificationManager.show({
            title: 'Nuova seduta',
            type: PopupType.Info,
            icon: 'bi-calendar-check-fill',
            children: (
                <div className='App mt-2'>
                    <div className='col'>
                        <div className='d-flex justify-content-between mb-3' style={{ gap: 10 }}>
                            <div>
                                <input
                                    id='startDate'
                                    className='form-control'
                                    type='date'
                                    {...workoutSessionCreateFormData.register('sessionDate')}
                                    onChange={event => {
                                        workoutSessionCreateFormData.setValue('sessionDate', event.target.value as string);
                                        console.log(workoutSessionCreateFormData.getValues('sessionDate'));
                                        handleSetDate(event.target.value as string);
                                    }}
                                />
                            </div>
                            <div className='text-start'>
                                <Select
                                    styles={reactSelectStyles}
                                    components={reactSelectComponents}
                                    id='workout'
                                    options={availableWorkoutTitles}
                                    {...workoutSessionCreateFormData.register('sessionID')}
                                    placeholder='Seleziona un workout'
                                    onChange={(choice: SelectableWorkout) => {
                                        console.log('choiceID', choice.value!);
                                        workoutSessionCreateFormData.setValue('sessionID', choice.value!);
                                        workoutSessionCreateFormData.setValue('sessionName', choice.label!);
                                        console.log(workoutSessionCreateFormData.getValues('sessionID'));
                                        console.log(workoutSessionCreateFormData.getValues('sessionName'));
                                        handleSelectWorkout(choice.value!);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            ctas: {
                primary: {
                    cta: async () => {
                        await handleCreateWorkoutSession(), await getWorkoutSessions();
                    },
                },
                secondary: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
                close: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
            },
        });
    };

    const getStatusBadge = (status?: string) => {
        switch (status) {
            case 'DONE':
                return { bg: '#e6f9ee', color: '#1a7f42', label: 'Completata' };
            case 'STARTED':
                return { bg: '#fff8e6', color: '#b08600', label: 'In corso' };
            case 'CANCELLED':
                return { bg: '#fef2f2', color: '#b91c1c', label: 'Annullata' };
            default:
                return { bg: '#f2f2f2', color: '#666', label: status ?? '—' };
        }
    };

    return (
        <PageTransition className='mt-4 px-3 px-md-4'>
            {/* ── Page Header ──────────────────────────────────────────── */}
            <div
                className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 p-4 anim-slide-up'
                style={{
                    background: 'linear-gradient(135deg, #fff 0%, #fafafa 100%)',
                    borderRadius: 12,
                    border: '1px solid rgba(0,0,0,0.06)',
                }}
            >
                <div>
                    <div className='d-flex align-items-center gap-2 mb-1'>
                        <i className='bi bi-calendar-check-fill' style={{ fontSize: '1.4rem', color: '#ff4949' }}></i>
                        <h4 className='mb-0 fw-bold' style={{ color: '#333' }}>Sedute</h4>
                    </div>
                    <p className='mb-0 mt-1' style={{ color: '#666', fontSize: '0.9rem' }}>
                        {customerItem.data?.details?.firstName && (
                            <>
                                <span className='fw-semibold' style={{ color: '#333' }}>
                                    {customerItem.data.details.firstName} {customerItem.data?.details?.lastName}
                                </span>
                                {' — '}
                            </>
                        )}
                        <span className='badge rounded-pill me-1' style={{ backgroundColor: '#ff4949', color: '#fff', fontSize: '0.8rem' }}>
                            {workoutSessions !== undefined ? workoutSessions.length : 0}
                        </span>
                        sedute totali
                    </p>
                </div>
                <div className='mt-3 mt-md-0'>
                    <Button
                        identifier='Nuova seduta'
                        icon={<i className='bi bi-plus-lg' style={{ fontSize: '1rem', color: 'white' }}></i>}
                        onClick={handleStartCreateSession}
                        variant='primary'
                    />
                </div>
            </div>

            {/* ── Calendar ─────────────────────────────────────────────── */}
            <div
                className='mb-4 p-4 anim-fade-in'
                style={{
                    background: '#fff',
                    borderRadius: 12,
                    border: '1px solid rgba(0,0,0,0.06)',
                }}
            >
                <div className='d-flex align-items-center gap-2 mb-3'>
                    <i className='bi bi-calendar3' style={{ fontSize: '1rem', color: '#ff4949' }}></i>
                    <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>Calendario</h6>
                </div>
                <BigCalendar
                    localizer={localizer}
                    onSelectEvent={(event: EventCalendar) => handleWorkoutSessionDetail(event.id)}
                    events={sessionEvents()}
                    startAccessor='start'
                    endAccessor='end'
                    style={{ height: 500 }}
                />
            </div>

            {/* ── Session List ─────────────────────────────────────────── */}
            {workoutSessions.length > 0 ? (
                <div className='mb-4'>
                    <div className='d-flex align-items-center gap-2 mb-3'>
                        <i className='bi bi-list-ul' style={{ fontSize: '1rem', color: '#ff4949' }}></i>
                        <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>Elenco sedute</h6>
                        <span className='badge rounded-pill ms-1' style={{ backgroundColor: '#f2f2f2', color: '#666', fontSize: '0.72rem' }}>
                            {workoutSessions.length} sedute
                        </span>
                    </div>
                    <div className='d-flex flex-column gap-2'>
                        {workoutSessions.map((workoutSession: ProgramSession, index: number) => {
                            const statusBadge = getStatusBadge(workoutSession.status);
                            return (
                                <div
                                    className='app-card anim-stagger'
                                    key={workoutSession.id || index}
                                    style={{
                                        '--anim-index': index,
                                        borderLeft: '3px solid #ff4949',
                                        padding: 0,
                                        overflow: 'hidden',
                                    } as React.CSSProperties}
                                >
                                    <div className='d-flex flex-column flex-lg-row align-items-lg-center justify-content-between p-3'>
                                        {/* ── Left: Icon + Info ─── */}
                                        <div className='d-flex align-items-center gap-3 flex-grow-1'>
                                            <div
                                                style={{
                                                    width: 42,
                                                    height: 42,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#fef2f2',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <i className='bi bi-lightning-fill' style={{ fontSize: '1rem', color: '#ff4949' }}></i>
                                            </div>
                                            <div className='d-flex flex-column' style={{ minWidth: 0 }}>
                                                <div className='d-flex align-items-center gap-2 flex-wrap'>
                                                    <h6 className='mb-0 fw-semibold text-truncate' style={{ color: '#222', fontSize: '0.95rem' }}>
                                                        {workoutSession.sessionName}
                                                    </h6>
                                                    <span
                                                        className='badge rounded-pill'
                                                        style={{
                                                            backgroundColor: statusBadge.bg,
                                                            color: statusBadge.color,
                                                            fontSize: '0.7rem',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        {statusBadge.label}
                                                    </span>
                                                </div>
                                                <div className='d-flex align-items-center gap-3 mt-1 flex-wrap'>
                                                    <span style={{ color: '#888', fontSize: '0.8rem' }}>
                                                        <i className='bi bi-calendar3 me-1' style={{ fontSize: '0.7rem' }}></i>
                                                        {moment(workoutSession.sessionDate).format('D MMM YYYY')}
                                                    </span>
                                                    {workoutSession.programName && (
                                                        <span
                                                            className='badge rounded-pill'
                                                            style={{ backgroundColor: '#f2f2f2', color: '#666', fontSize: '0.72rem', fontWeight: 500 }}
                                                        >
                                                            <i className='bi bi-clipboard2 me-1' style={{ fontSize: '0.65rem' }}></i>
                                                            {workoutSession.programName}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* ── Right: Actions ─── */}
                                        <div className='d-flex align-items-center gap-2 mt-3 mt-lg-0 ms-lg-3 flex-shrink-0 flex-wrap'>
                                            <Button
                                                icon={<i className='bi bi-eye-fill' style={{ fontSize: '1rem', color: 'white' }}></i>}
                                                identifier='Dettagli'
                                                variant='primary'
                                                onClick={() => handleWorkoutSessionDetail(workoutSession.id!)}
                                            />
                                            <Button
                                                icon={<i className='bi bi-copy' style={{ fontSize: '0.9rem' }}></i>}
                                                identifier='Duplica'
                                                variant='secondary'
                                                onClick={() => handleStartDuplicate(workoutSession)}
                                            />
                                            <Button
                                                icon={<i className='bi bi-calendar-event' style={{ fontSize: '0.9rem' }}></i>}
                                                variant='secondary'
                                                onClick={() => handleStartChangeDate(workoutSession.id!, workoutSession.sessionDate!)}
                                            />
                                            <Button
                                                icon={<i className='bi bi-trash3-fill' style={{ fontSize: '0.9rem' }}></i>}
                                                variant='secondary'
                                                onClick={() => handleWorkoutSessionDelete(workoutSession.id!)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : (
                <EmptyState
                    icon='bi bi-calendar-x'
                    title='Nessuna seduta'
                    description='Non ci sono ancora sedute per questo cliente. Crea la prima seduta.'
                    action={
                        <Button
                            identifier='Nuova seduta'
                            icon={<i className='bi bi-plus-lg' style={{ fontSize: '1rem', color: 'white' }}></i>}
                            onClick={handleStartCreateSession}
                            variant='primary'
                        />
                    }
                />
            )}

            {/* ── Reschedule Panel ─────────────────────────────────────── */}
            <div
                className={`session-create-panel row align-items-center justify-content-between px-4 mx-0 ${newSessionDate == true ? 'session-create-panel--open' : ''}`}
                style={{ backgroundColor: '#f5f5f5', borderRadius: 10 }}
            >
                {newSessionDate == true && (
                    <>
                        <div className='col-8 d-flex justify-content-start'>
                            <Calendar
                                identifier={''}
                                {...workoutSessionCreateFormData.register('sessionDate')}
                                selected={
                                    workoutSessionCreateFormData.getValues('sessionDate') == undefined
                                        ? new Date()
                                        : moment(workoutSessionCreateFormData.getValues('sessionDate')).toDate()
                                }
                                onChange={date => {
                                    workoutSessionCreateFormData.setValue('sessionDate', date as Date);
                                    console.log(workoutSessionCreateFormData.getValues('sessionDate'));
                                }}
                            />
                        </div>
                        <div className='col-4 d-flex justify-content-end gap-3'>
                            <Button
                                identifier='Salva'
                                variant='primary'
                                onClick={() => {
                                    handleChangeDate();
                                    setNewSessionDate(false);
                                }}
                            />
                            <Button
                                identifier='Annulla'
                                variant='secondary'
                                onClick={() => {
                                    setNewSessionDate(false);
                                    workoutSessionCreateFormData.resetField('sessionDate');
                                    workoutSessionCreateFormData.resetField('sessionID');
                                }}
                            />
                        </div>
                    </>
                )}
            </div>
        </PageTransition>
    );
};
